module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_dinnerparty-3eda353943432273977dde9f581aa279.jpg";